const record = (value: unknown): Record<string, unknown> | null =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
const text = (value: unknown, max = 120): string | undefined =>
  typeof value === 'string' && value.length > 0 && value.length <= max ? value : undefined;
/** Only display the public inventory, never arbitrary keys from an adapter observation. */
export function readEnvironmentInventory(observed: unknown) {
  const value = record(observed),
    version = text(value?.version, 60);
  if (!value || !version) return null;
  const components = Object.entries(record(value.plugins) ?? record(value.modules) ?? {})
    .slice(0, 40)
    .flatMap(([name, item]) => {
      const data = record(item);
      if (!text(name) || typeof data?.installed !== 'boolean' || typeof data.active !== 'boolean')
        return [];
      return [
        {
          name,
          installed: data.installed,
          active: data.active,
          version: text(data.version, 60) ?? null,
        },
      ];
    });
  return {
    version,
    theme: text(value.theme),
    themeVersion: text(value.themeVersion, 60),
    components,
  };
}
